import React, { memo, MouseEvent } from 'react'
import { SortArrowToggle } from 'transfix-ui/components/SortArrowToggle'
import { SORT_ORDER } from 'apps/fleet-planner/types/base'
import { SORT_FIELD } from 'apps/fleet-planner/types/loads'
import { TableHead, TableRow, TableCell } from 'transfix-ui'

interface ISortingProps {
  sortField?: SORT_FIELD
  sortOrder?: SORT_ORDER
  onSortingChange: (sortField: SORT_FIELD) => void
}

export const LoadsTableHeader = memo<ISortingProps>(({ onSortingChange, sortField, sortOrder }) => {
  const sortHandler = (e: MouseEvent<HTMLButtonElement>) =>
    onSortingChange(e.currentTarget.value as SORT_FIELD)
  return (
    <TableHead>
      <TableRow tableCellType='th'>
        <TableCell dataTest='load-id-column-header'>Load ID</TableCell>
        <TableCell dataTest='customer-column-header'>Customer</TableCell>
        <TableCell dataTest='pickupTime-column-header'>
          <button className='sort' value={SORT_FIELD.PICKUP} onClick={sortHandler}>
            Pickup
            <SortArrowToggle direction={sortField === SORT_FIELD.PICKUP ? sortOrder : undefined} />
          </button>
        </TableCell>
        <TableCell dataTest='dropoffTime-column-header'>
          <button className='sort' value={SORT_FIELD.DROPOFF} onClick={sortHandler}>
            Dropoff
            <SortArrowToggle direction={sortField === SORT_FIELD.DROPOFF ? sortOrder : undefined} />
          </button>
        </TableCell>
        <TableCell dataTest='trailer-column-header'>Trailer</TableCell>
        <TableCell dataTest='drivers-column-header'>Drivers</TableCell>
        <TableCell dataTest='status-column-header'>Status</TableCell>
        <TableCell dataTest='last-activity-column-header'>
          <button className='sort' value={SORT_FIELD.MOST_RECENT_ACTIVITY} onClick={sortHandler}>
            Last Activity{' '}
            <SortArrowToggle
              direction={sortField === SORT_FIELD.MOST_RECENT_ACTIVITY ? sortOrder : undefined}
            />
          </button>
        </TableCell>
        <TableCell type='icon'>&nbsp;</TableCell>
      </TableRow>
    </TableHead>
  )
})
